<div class="container-fluid dashboard-wrapper mt-1">

  <!-- HEADER CARD -->
<div class="dashboard-header-card">

  <div class="dashboard-title-wrap">
    <i class="fas fa-chalkboard-teacher"></i>
    <span>Faculty Dashboard</span>
  </div>

  <div class="dashboard-actions">
    <button class="btn dash-btn refresh" (click)="refresh()">
      <i class="fas fa-sync-alt"></i>
      Refresh
    </button>

    <!-- <button class="btn dash-btn logout" (click)="onLogout()">
      <i class="fas fa-right-from-bracket"></i>
      Logout
    </button> -->
  </div>

</div>


  <!-- STATUS MESSAGE -->
  <div *ngIf="progressMessage" class="alert alert-info brand-alert">
    {{ progressMessage }}
  </div>

  <!-- BATCH CARDS -->
  <div class="row">
    <div class="col-xl-3 col-lg-4 col-md-6 mb-4" *ngFor="let b of batches">
      <div class="batch-card h-100">
          <!-- Card Header -->
          <div class="batch-title">{{ b.BatchName }}</div>
          <!-- Card Info -->
          <div class="batch-info">
            <!-- <p><strong>Batch ID:</strong> {{ b.SDBatchId }}</p> -->
            <p><strong>Valid From:</strong> {{ b.StartDate | date }}</p>
            <p><strong>Valid Till:</strong> {{ b.EndDate | date }}</p>
            <p><strong>Rounds Played:</strong> {{ b.RoundsPlayed }}</p>
            <p><strong>Real Teams:</strong> {{ b.NumberofRealTeams }}</p>
            <p><strong>Virtual Teams:</strong> {{ b.NumberofVirtualTeams }}</p>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="batch-actions">

            <button class="btn dash-btn primary" (click)="pushEvents(b)">
              <i class="fas fa-bolt"></i> Push Events
            </button>

            <button class="btn dash-btn warning" (click)="pushAutoVals(b)">
              <i class="fas fa-robot"></i> Push Autovals
            </button>

            <button class="btn dash-btn success" (click)="processRound(b)">
              <i class="fas fa-play-circle"></i> Process Round
            </button>

            <button class="btn dash-btn info" (click)="getReports(b)">
              <i class="fas fa-file-lines"></i> Get Reports
            </button>

             <button class="btn dash-btn secondary" (click)="restorePreviousRound(b)">
              <i class="fa fa-solid fa-arrows-rotate"></i> Restore Previous Round
            </button>

          </div>

          <!-- STATUS -->
          <div class="status" *ngIf="status">
            Status: <span>{{ status }}</span>
          </div>

      </div>
    </div>
  </div>

</div>
